import script from "./ImportProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportProfile.vue?vue&type=script&setup=true&lang=ts"

import "./ImportProfile.vue?vue&type=style&index=0&id=133dd4e4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133dd4e4"]])

export default __exports__